import { ChangeDetectorRef, Directive, OnInit, OnDestroy } from '@angular/core';
import { MultiSelectComponent } from '@progress/kendo-angular-dropdowns';

@Directive({
  standalone: false,
  selector: '[tiDropDownButton]',
})
export class DropDownButtonDirective implements OnInit, OnDestroy {
  private button: HTMLElement;
  private clickHandler: any;
  constructor(
    private component: MultiSelectComponent,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.button = document.createElement('span');
    this.button.className = 'k-combobox';

    this.button.style.minWidth = '0';
    this.button.style.maxHeight = '2.25rem'; // not really necessary
    this.button.style.height = '100%';
    this.button.style.right = '0';
    this.button.style.position = 'absolute';

    let buttonChild3 = document.createElement('span');
    buttonChild3.className = 'k-i-caret-alt-down k-icon';
    buttonChild3.appendChild(document.createTextNode(''));

    let buttonChild2 = document.createElement('span');
    buttonChild2.className = 'k-select';
    buttonChild2.appendChild(buttonChild3);

    let buttonChild = document.createElement('span');
    buttonChild.className = 'k-dropdown-wrap';
    buttonChild.appendChild(buttonChild2);
    buttonChild.style.border = 'none';

    this.button.appendChild(buttonChild);

    let cdr = this.cdr;
    let component = this.component;
    let clickHandler = () => {
      component.toggle(!component.isOpen);
      cdr.markForCheck();
    };

    this.clickHandler = clickHandler;

    if (this.component.wrapper) {
      this.component.wrapper.nativeElement.appendChild(this.button);
    }
  }

  ngOnDestroy() {
    if (this.button) {
      this.button.removeEventListener('click', this.clickHandler);
    }
  }
}
